const INTEGRATION_DISPLAY_NAMES: Record<string, string> = {
  FlashApi: "Flash",
};

export function getIntegrationDisplayName(
  name: string | null | undefined
): string {
  if (!name) return "";
  return INTEGRATION_DISPLAY_NAMES[name] ?? name;
}
